// This function can be used to have a special behavior between two breakpoints when
// the user resizes his / her screen screen.
// It takes three arguments:
// The two first ones MUST be functions or null: doThisOnMobile, doThatOnDesktop.
// The last one is the Breakpoint (in pixels) of the biggest screen.

let windowWidth = window.innerWidth;

export const screenResizerChecker = (doThisOnSmallerScreen, doThatOnBiggerScreen, biggerScreenBreakpoint) => {
  let screenChanged = null;

  const checkScreenSize = () => {
    // return if screen dont change
    if (screenChanged && screenChanged === window.matchMedia(`(min-width: ${biggerScreenBreakpoint}px)`).matches) return;

    // If we are on mobile
    if (window.matchMedia(`(max-width: ${(biggerScreenBreakpoint - 1)}px)`).matches) {
      doThisOnSmallerScreen && doThisOnSmallerScreen();
    } else {
      doThatOnBiggerScreen && doThatOnBiggerScreen();
    }
    screenChanged = window.matchMedia(`(min-width: ${biggerScreenBreakpoint}px)`).matches;
  };

  // initialize
  checkScreenSize();

  // Timer not to run the code on every px during resize.
  let timer = null;
  $(window).on('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (windowWidth !== window.innerWidth) {
        checkScreenSize();
        windowWidth = window.innerWidth;
      }
    }, 100);
  });
};
